var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "new-customer" }, [
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            {
              attrs: { label: "Nombre de cliente", "label-for": "privateName" }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateName",
                  placeholder: "Rafaeli Camposorio Ruízo",
                  icon: "account",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("name", $event)
                  }
                },
                model: {
                  value: _vm.privateName,
                  callback: function($$v) {
                    _vm.privateName = $$v
                  },
                  expression: "privateName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            { attrs: { label: "Email", "label-for": "privateEmail" } },
            [
              _c("BInput", {
                attrs: {
                  id: "privateEmail",
                  placeholder: "correo@mail.com",
                  icon: "email",
                  type: "email",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("email", $event)
                  }
                },
                model: {
                  value: _vm.privateEmail,
                  callback: function($$v) {
                    _vm.privateEmail = $$v
                  },
                  expression: "privateEmail"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            { attrs: { label: "RFC", "label-for": "privateRfc" } },
            [
              _c("BInput", {
                attrs: {
                  id: "privateRfc",
                  placeholder: "PAL7202161U0",
                  icon: "fingerprint",
                  pattern: _vm.rfcPattern,
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("rfc", $event)
                  }
                },
                model: {
                  value: _vm.privateRfc,
                  callback: function($$v) {
                    _vm.privateRfc = $$v
                  },
                  expression: "privateRfc"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Razón social",
                "label-for": "privateCompanyName"
              }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateCompanyName",
                  placeholder: "Machete SA de CV",
                  icon: "domain",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("companyName", $event)
                  }
                },
                model: {
                  value: _vm.privateCompanyName,
                  callback: function($$v) {
                    _vm.privateCompanyName = $$v
                  },
                  expression: "privateCompanyName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c("AppSelectSearch", {
            attrs: {
              id: "privateTaxRegime",
              name: "privateTaxRegime",
              label: "Régimen fiscal",
              icon: "domain",
              options: _vm.taxRegimeCatalog,
              value: _vm.taxRegimeSelected(),
              required: ""
            },
            on: {
              input: function($event) {
                return _vm.onInput("taxRegime", $event.target.value)
              },
              change: function($event) {
                return _vm.onInput("taxRegime", $event.target.value)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            {
              attrs: { label: "Código postal", "label-for": "privateZipCode" }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateZipCode",
                  placeholder: "00000",
                  icon: "account-card-details",
                  pattern: _vm.zipCodePattern,
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("zipCode", $event)
                  }
                },
                model: {
                  value: _vm.privateZipCode,
                  callback: function($$v) {
                    _vm.privateZipCode = $$v
                  },
                  expression: "privateZipCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Télefono celular",
                "label-for": "privateCellphoneNumber"
              }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateCellphoneNumber",
                  placeholder: "5555555555",
                  icon: "domain",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("cellphoneNumber", $event)
                  }
                },
                model: {
                  value: _vm.privateCellphoneNumber,
                  callback: function($$v) {
                    _vm.privateCellphoneNumber = $$v
                  },
                  expression: "privateCellphoneNumber"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Días de crédito",
                "label-for": "privateCreditDays"
              }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateCreditDays",
                  placeholder: "30",
                  icon: "bank",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("creditDays", $event)
                  }
                },
                model: {
                  value: _vm.privateCreditDays,
                  callback: function($$v) {
                    _vm.privateCreditDays = $$v
                  },
                  expression: "privateCreditDays"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Limite de crédito",
                "label-for": "privateCreditLimit"
              }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateCreditLimit",
                  placeholder: "30",
                  icon: "bank",
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  required: ""
                },
                on: {
                  input: function($event) {
                    return _vm.onInput("creditLimit", $event)
                  }
                },
                model: {
                  value: _vm.privateCreditLimit,
                  callback: function($$v) {
                    _vm.privateCreditLimit = $$v
                  },
                  expression: "privateCreditLimit"
                }
              })
            ],
            1
          ),
          _c("p", { staticClass: "help" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("toCurrency")(_vm.privateCreditLimit, "MXN")) +
                "\n      "
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }